import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api } from '../../api/client'
import type { DeviceRegistration } from '../../lib/types'

export function useUnreadCount() {
  return useQuery({ queryKey: ['unread'], queryFn: api.unreadCount })
}

export function useNotifications(unreadOnly = false) {
  return useQuery({ queryKey: ['notifications', unreadOnly], queryFn: () => api.notifications(unreadOnly) })
}

export function useReadNotification() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => api.readNotification(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['notifications'] })
      qc.invalidateQueries({ queryKey: ['unread'] })
    },
  })
}

export function useReadAllNotifications() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: () => api.readAllNotifications(),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['notifications'] })
      qc.invalidateQueries({ queryKey: ['unread'] })
    },
  })
}

/**
 * Регистрация Expo push-токена (POST /notifications/devices, идемпотентный upsert).
 * Доставка push — фаза 2 (нативные сборки + expo-notifications); сам токен получаем
 * там же. Этот хук — готовая обёртка, чтобы вызвать его, как только токен доступен.
 */
export function useRegisterDevice() {
  return useMutation({
    mutationFn: (data: DeviceRegistration) => api.registerDevice(data),
  })
}

/** Снять токен при logout (DELETE /notifications/devices → 204). */
export function useUnregisterDevice() {
  return useMutation({
    mutationFn: (token: string) => api.unregisterDevice(token),
  })
}
